import { SessionHelper } from "app/helpers/sessionHelper";
import { Redirect } from "react-router-dom";
import ENV from "../../../../../../../config";
type Props = {};

const DesktopRouterRedirects: React.FC<Props> = () => {
  const checkLoggedInDefaultRoute = () => {
    if (SessionHelper.isAsianSessionView()) {
      return <Redirect to="/asian/events/" />;
    }
    return <Redirect to="/events/" />;
  };

  const checkWhiteLabelDefaultRoute = () => {
    if (ENV.CSS_THEME !== "DEFAULT") {
      return <Redirect to="/login" />;
    }
    return <Redirect to="/" />;
  };

  return SessionHelper.isAuthenticated()
    ? checkLoggedInDefaultRoute()
    : checkWhiteLabelDefaultRoute();
};

export default DesktopRouterRedirects;
